import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  ALL_USERS_OPTION_ID,
  IStatisticsFormModel,
  statisticsFormDefaultValues,
  statisticsFormSchema,
} from "../models/statisticsFormModel";
import { useEffect } from "react";
import { ISelectFieldModel } from "../../../common/components/forms/inputs/dropdown/models/selectFieldModel";

export const useStatisticsForm = (
  employees?: ISelectFieldModel[],
  initialValues?: Partial<IStatisticsFormModel>,
  canSeeAllEmployees: boolean = true,
  currentUserId?: number
) => {
  const defaultValues = initialValues
    ? { ...statisticsFormDefaultValues, ...initialValues }
    : statisticsFormDefaultValues;

  const form = useForm<IStatisticsFormModel>({
    defaultValues,
    resolver: yupResolver(statisticsFormSchema),
  });

  useEffect(() => {
    if (!employees) return;

    const currentUserIds = form.getValues("userIds") ?? [];

    if (!canSeeAllEmployees) {
      // Users below Manager can only ever query themselves. Coerce any
      // "All" sentinel or unauthorized ids that leaked in from URL params.
      const selfOnly =
        currentUserId != null && employees.some((e) => e.id === currentUserId)
          ? [currentUserId]
          : employees.length > 0
            ? [employees[0].id]
            : [];

      const containsForeign = currentUserIds.some(
        (id) => id === ALL_USERS_OPTION_ID || (currentUserId != null && id !== currentUserId)
      );
      if (currentUserIds.length === 0 || containsForeign) {
        form.setValue("userIds", selfOnly);
      }
      return;
    }

    if (currentUserIds.length === 0) {
      // Default to the "All employees" sentinel rather than the first employee, so
      // managers see studio-wide totals (incl. admin-created activity) out of the box.
      form.setValue("userIds", [ALL_USERS_OPTION_ID]);
    }
  }, [employees, canSeeAllEmployees, currentUserId]);

  return form;
};
